import React from 'react'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Box, Flex, Text } from 'pcln-design-system'
import { ActionCard } from '@pcln/cards'
import useRecentSearchCard from '@/hooks/useRecentSearchCard'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import useBootstrapData from '@/hooks/useBootstrapData'
import LayoutComponentWrapper from '../LayoutComponentWrapper'
import getProductInfo from './utils'

const StyledFlex = styled(Flex)`
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
`

const StyledScroll = styled(Flex)`
  overflow: auto;
  gap: 16px;
  &::-webkit-scrollbar {
    display: none;
  }
  ${themeGet('mediaQueries.md')} {
    overflow: visible;
  }
`

export default function RecentSearchCards() {
  const {
    webstats: { clientGUID },
    appName,
    appVersion
  } = useBootstrapData()
  const data = useRecentSearchCard(clientGUID, { appName, appVersion })
  const firstTwoCards = data.length > 2 ? data.slice(0, 2) : data
  const recentSearchCards = firstTwoCards.map((item, index) => {
    const { heading, icon, title, subtitle, url } = getProductInfo(item)
    return (
      <Box width={['300px', null, null, '388px']}>
        <ActionCard
          key={heading || index}
          titleWidth={['224px', null, null, '300px']}
          icon={icon}
          title={title}
          subTitle={subtitle}
          heading={heading}
          onClick={() => {
            analytics.fireEvent({
              category: ANALYTICS_CATEGORY_HOME,
              action: 'Personalized Shortcut',
              label: 'Recent Search Shortcut'
            })
            window.open(url)
          }}
          handleSubmitCTA={() => {
            analytics.fireEvent({
              category: ANALYTICS_CATEGORY_HOME,
              action: 'Personalized Shortcut',
              label: 'Recent Search Shortcut'
            })
            window.open(url)
          }}
        />
      </Box>
    )
  })
  return recentSearchCards.length ? (
    <LayoutComponentWrapper>
      <StyledFlex>
        <Text width="100%" mb={2} textStyle="heading5">
          Your Recent Searches
        </Text>
        <StyledScroll
          width="100%"
          pl={[2, null, 0]}
          ml={['-8px', null, 0]}
          py={[4, null, 0]}
          my={['-32px', null, 0]}
        >
          {recentSearchCards}
        </StyledScroll>
      </StyledFlex>
    </LayoutComponentWrapper>
  ) : null
}
